"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./PersonaCoin"), exports);
tslib_1.__exportStar(require("./PersonaCoin.base"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Persona/PersonaCoin/index.js
// module id = 1622
// module chunks = 0